import { useMutation, gql } from "@apollo/client"

const DELETEACTION_MUTATION = gql`
  mutation DeleteAction($id: ID!) {
    deleteAction(id: $id)
  }
`

const useMutationDeleteAction = () => useMutation(DELETEACTION_MUTATION)

export { useMutationDeleteAction }
